export default __webpack_public_path__ + "static/media/activate-staff.24ac3d14.png";